module.exports = __webpack_public_path__ + "static/media/autochilango-plus.890395c6.svg";